import { ToggleGroup } from '@interstate/components/ToggleGroup';
import { APR_PERCENTAGE, MONEY_FACTOR } from '../../constants';

interface RateTypeToggleGroupProps {
    inputField: string;
    isAPRRateType: boolean;
    handleOnClick: (event?: React.MouseEvent<Element, MouseEvent>) => void;
    disabled?: boolean;
    toggleWidth?: string;
}

const RateTypeToggleGroup = (props: RateTypeToggleGroupProps) => {
    const { inputField, isAPRRateType, handleOnClick, disabled, toggleWidth = '3.75rem' } = props;

    return (
        <ToggleGroup
            size="sm"
            id={`${inputField}-input-toggle-group`}
            data-testid={`${inputField}-input-toggle-group`}
            toggleButtonOptions={[
                {
                    id: 'moneyFactorToggle',
                    value: MONEY_FACTOR,
                    children: <span>{MONEY_FACTOR}</span>,
                    selected: !isAPRRateType,
                    'data-testid': `${inputField}-money-factor`,
                    ...(!disabled && { onClick: handleOnClick })
                },
                {
                    id: 'percentToggle',
                    value: APR_PERCENTAGE,
                    children: <span>{APR_PERCENTAGE}</span>,
                    selected: isAPRRateType,
                    'data-testid': `${inputField}-apr`,
                    ...(!disabled && { onClick: handleOnClick })
                }
            ]}
            toggleWidth={toggleWidth}
        />
    );
};

export default RateTypeToggleGroup;
